// packages/content/src/tuning/auth.ts
import type { TuningBank } from '../schema/tuning';
export default { otpLength: 6, otpTtlSeconds: 600, otpAttempts: 5, sessionDays: 90, sessionUpdateAgeHours: 24 } as const satisfies TuningBank;   // §7.2 (contract change 31)
